import { gql } from "@apollo/client";

export const GET_BADGES = gql`
  query getBadges {
    badge {
      badge_id
      name
      description
      icon_url
      criteria_type
      criteria_value
      created_at
      updated_at
    }
  }
`;

export const GET_BADGE_BY_ID = gql`
  query getBadgeById($badgeId: uuid!) {
    badge_by_pk(badge_id: $badgeId) {
      badge_id
      name
      description
      icon_url
      criteria_type
      criteria_value
      created_at
      updated_at
    }
  }
`;

export const GET_USER_BADGES = gql`
  query getUserBadges($userId: uuid!) {
    user_badge(where: { user_id: { _eq: $userId } }) {
      user_badge_id
      badge_id
      user_id
      badge {
        badge_id
        name
        description
        icon_url
        criteria_type
        criteria_value
      }
    }
  }
`;
